import { GlIcon, GlPopover, GlLink, GlSkeletonLoader, GlProgressBar, GlTooltipDirective } from '@gitlab/ui';
import TimeboxStatusBadge from 'ee_component/iterations/components/timebox_status_badge.vue';
import { __, sprintf } from '~/locale';
import { humanTimeframe, localeDateFormat, newDate } from '~/lib/utils/datetime_utility';
import { convertToGraphQLId } from '~/graphql_shared/utils';
import query from '~/issuable/popover/queries/iteration.query.graphql';
export default {
    name: 'IterationPopover',
    components: {
        GlIcon,
        GlPopover,
        GlLink,
        GlProgressBar,
        GlSkeletonLoader,
        TimeboxStatusBadge
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        target: {
            type: HTMLAnchorElement,
            required: true
        },
        iterationId: {
            type: String,
            required: true
        },
        namespacePath: {
            type: String,
            required: true
        },
        cachedTitle: {
            type: String,
            required: true
        },
        placement: {
            type: String,
            required: false,
            default: 'top'
        }
    },
    data () {
        return {
            iteration: {}
        };
    },
    computed: {
        loading () {
            return this.$apollo.queries.iteration.loading;
        },
        title () {
            return this.iteration?.iterationCadence?.title || this.cachedTitle.split('%').slice(-1).pop();
        },
        iterationStats () {
            return this.iteration?.report?.stats || {};
        },
        groupFullPath () {
            return this.iteration?.group?.fullPath || '';
        },
        progress () {
            const complete = this.iterationStats.complete.count;
            const total = this.iterationStats.total.count;
            if (total !== 0) {
                return Math.floor(complete / total * 100);
            }
            return 0;
        },
        showTimeframe () {
            return !this.loading && Boolean(this.iterationTimeframe);
        },
        showProgress () {
            return this.iterationStats.total && this.iterationStats.complete;
        },
        percentageComplete () {
            return sprintf(__('%{percentage}%% complete'), {
                percentage: this.progress
            });
        },
        iterationTimeframe () {
            const { startDate, dueDate } = this.iteration;
            const today = new Date();
            let timeframe = '';
            if (startDate && dueDate) {
                timeframe = humanTimeframe(newDate(startDate), newDate(dueDate));
            } else if (startDate && !dueDate) {
                const parsedStartDate = newDate(startDate);
                const startDateInWords = localeDateFormat.asDate.format(parsedStartDate);
                if (parsedStartDate.getTime() > today.getTime()) {
                    timeframe = sprintf(__('Starts %{startDate}'), {
                        startDate: startDateInWords
                    });
                } else {
                    timeframe = sprintf(__('Started %{startDate}'), {
                        startDate: startDateInWords
                    });
                }
            } else if (!startDate && dueDate) {
                const parsedDueDate = newDate(dueDate);
                const dueDateInWords = localeDateFormat.asDate.format(parsedDueDate);
                if (parsedDueDate.getTime() > today.getTime()) {
                    timeframe = sprintf(__('Ends %{dueDate}'), {
                        dueDate: dueDateInWords
                    });
                } else {
                    timeframe = sprintf(__('Ended %{dueDate}'), {
                        dueDate: dueDateInWords
                    });
                }
            }
            return timeframe;
        }
    },
    apollo: {
        iteration: {
            query,
            variables () {
                return {
                    id: convertToGraphQLId(`Iteration`, this.iterationId),
                    fullPath: this.namespacePath
                };
            },
            update: (data)=>data.iteration
        }
    }
};
